import axios from "axios";
import React, { useEffect, useState } from "react";
import { AUTH, AUTHH, BASE_URL, IMAGE_URL } from "../../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import { formatDate, formattedDateLong } from "../../Date";
import { Modal } from "react-bootstrap";
import Dashboardnavbar from "../../../layout/Dashboardnavbar";
import { formatCurrencyIndian, formatDateTime, formatRoundoff2D, handleErrorToast, getMonthName, ViewDocumnetsbilling, inputMaxLimit } from '../../CustomFunctions';
import usePermission from '../../../config/permissions';
import { CheckGreen, WarnYellow, Eye, Filter, Office, CrossRed, Attachment, Employee } from '../../AllSvg';
import { Projects } from '../../FilterDropdown';




const ApproveRequestExpenseBillingChecker = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [maxlimit, setMaxlimit] = useState('')
    const [maxlimittds, setMaxlimittds] = useState('')
    const handleShow = () => {
        setMaxlimittds(parseFloat(i.tds_percentage).toFixed(2))
        setMaxlimit(parseFloat(i.rent_amt).toFixed(2));
        setFormData(i)
        setShow(true)
    };

    const [formData, setFormData] = useState({
        rent_amt: '',
        tds_percentage: '',
        tds_amt: '',
        total_amt: '',
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let updatedData = { ...formData, [name]: value };

        if (name === "rent_amt") {
            // const maxLimit = parseFloat(formData.rent_amt).toFixed(2);
            console.log(maxlimit)
            const rentAmount = parseFloat(value).toFixed(2);
            const { success, error } = inputMaxLimit(name, rentAmount, maxlimit);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
                return updatedData;
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "",
                }));
                if (rentAmount >= 50000) {
                    const tdsPercentage = 10;
                    const tdsAmount = parseFloat(((rentAmount * tdsPercentage) / 100).toFixed(2));
                    updatedData = {
                        ...updatedData,
                        tds_percentage: tdsPercentage,
                        tds_amt: tdsAmount,
                        total_amt: parseFloat((parseFloat(rentAmount) - tdsAmount).toFixed(2)),
                    };
                } else {
                    updatedData = {
                        ...updatedData,
                        tds_percentage: "",
                        tds_amt: 0,
                        total_amt: parseFloat(rentAmount),
                    };
                }
            }

        }

        if (name === "tds_percentage" && Number(formData.rent_amt) >= 50000) {
            const tdsPercentage = parseFloat(value).toFixed(2);
            const { success, error } = inputMaxLimit(name, tdsPercentage, maxlimittds);
            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
                return updatedData;
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "",
                }));
                const tdsAmount = parseFloat(((Number(formData.rent_amt) * tdsPercentage) / 100).toFixed(2));
                updatedData = {
                    ...updatedData,
                    tds_amt: tdsAmount,
                    total_amt: parseFloat((Number(formData.rent_amt) - tdsAmount).toFixed(2)),
                };
            }

        }

        setFormData(updatedData);

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        if (errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...restErrors } = prevErrors;
                return restErrors;
            });
        }
    };

    const handleFormSubmitPut = async (e) => {

        e.preventDefault();

        const updatedFormData = {
            ...formData,
            checker_approval_status: 'approved',
            checker: sessionStorage.getItem('sitemanagement_emp_code'),
            checker_update_datetime: new Date().toISOString(),
        };


        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Checker Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};
const RejectRequestExpenseBillingChecker = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        checker_rejection_reason: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["checker_rejection_reason"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    checker_approval_status: "rejected",
                    checker_rejection_reason: formData.checker_rejection_reason,
                    checker_update_datetime: new Date().toISOString(),
                    checker: sessionStorage.getItem('sitemanagement_emp_code'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin Imprest Reject" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M13.5 4.5L4.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 4.5L13.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="checker_rejection_reason" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Checker Rejection Reason
                                </label>
                                <textarea
                                    id="checker_rejection_reason"
                                    type="text"
                                    name="checker_rejection_reason"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.checker_rejection_reason}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.checker_rejection_reason
                                        ? "error"
                                        : inputState.checker_rejection_reason
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.checker_rejection_reason && (
                                    <span className="error-message font-size-text ">{errors.checker_rejection_reason}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ApproveRequestExpenseBillingAuthority = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [formData, setFormData] = useState({
        rent_amt: '',
        tds_percentage: '',
        tds_amt: '',
        total_amt: '',
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleFormSubmitPut = async (e) => {

        e.preventDefault();

        const updatedFormData = {
            authority_approval_status: 'approved',
            authority_engineer: sessionStorage.getItem('sitemanagement_emp_code'),
            authority_update_datetime: new Date().toISOString(),
        };
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic


            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }


            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Authority Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};
const RejectRequestExpenseBillingAuthority = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        authority_rejection_reason: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["authority_rejection_reason"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    authority_approval_status: "rejected",
                    authority_engineer: sessionStorage.getItem('emp_code'),
                    authority_rejection_reason: formData.authority_rejection_reason,
                    authority_update_datetime: new Date().toISOString(),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin Imprest Reject" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M13.5 4.5L4.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 4.5L13.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column">
                                <div className="flex-row">
                                    <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                        Date :
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.date ? formatDate(i.date) : "-"}
                                    </div>
                                </div>

                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Months:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {getMonthName(i.month)}
                                    </div>
                                </div>

                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Year:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.year}
                                    </div>
                                </div>

                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Project :
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i?.vehicle_details?.project_short_name}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Vehicle Name:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.vehicle_name}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Vehicle Number:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.vehicle_num}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Fixed Km:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.fixed_km}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Extra Km:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.extra_km}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Total Km:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {i.total_km}
                                    </div>
                                </div>




                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Fixed Bill Amount:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {formatCurrencyIndian(i.fixed_bill_amt)}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Extra Amount Per KM <br /> After Fixed KM :
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                    </div>
                                </div>

                                <div className="flex-row">
                                    <label
                                        htmlFor="project_name"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Extra Charges:
                                    </label>
                                    <div className="form-labels announce-date font-size-heading padding-lefttt">
                                        {formatCurrencyIndian(i.total_amt)}
                                    </div>
                                </div>
                                <div className="flex-row">
                                    <ViewDocumnetsbilling documentlist={documentlist} />
                                </div>
                                <label htmlFor="authority_rejection_reason" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Authority Rejection Reason
                                </label>
                                <textarea
                                    id="authority_rejection_reason"
                                    type="text"
                                    name="authority_rejection_reason"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.authority_rejection_reason}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.authority_rejection_reason
                                        ? "error"
                                        : inputState.authority_rejection_reason
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.authority_rejection_reason && (
                                    <span className="error-message font-size-text ">{errors.authority_rejection_reason}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ApproveRequestExpenseBillingAccStage1 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    const [formData, setFormData] = useState({});

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const handleFormSubmitPut = async (e) => {

        e.preventDefault();
        console.log('clicked')
        console.log(validateForm())
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const updatedFormData = {
                account_status_a: "approved",
                account_update_datetime: new Date().toISOString(),
                account_update_by: sessionStorage.getItem('sitemanagement_emp_id'),
            };

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Account Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};
const RejectRequestExpenseBillingAccStage1 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        account1_rejection_reason: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["account1_rejection_reason"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    account_status_a: "rejected",

                    account1_rejection_reason: formData.account1_rejection_reason,
                    account_update_datetime: new Date().toISOString(),
                    account_update_by: sessionStorage.getItem('sitemanagement_emp_code'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin Imprest Reject" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M13.5 4.5L4.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 4.5L13.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="account1_rejection_reason" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Admin Rejection Reason
                                </label>
                                <textarea
                                    id="account1_rejection_reason"
                                    type="text"
                                    name="account1_rejection_reason"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.account1_rejection_reason}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.account1_rejection_reason
                                        ? "error"
                                        : inputState.account1_rejection_reason
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.account1_rejection_reason && (
                                    <span className="error-message font-size-text ">{errors.account1_rejection_reason}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ApprovedExpenseBillingAdminC1 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [formData, setFormData] = useState({});


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleFormSubmitPut = async (e) => {

        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                admin_approval_status_c1: "approved",
                admin_update_datetime_c1: new Date().toISOString(),
                admin_update_by_c1: sessionStorage.getItem('sitemanagement_emp_code'),
            };
            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Admin Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};

const RejectExpenseBillingAdminC1 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        admin_rejection_reason_c1: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["admin_rejection_reason_c1"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    admin_approval_status_c1: "rejected",
                    admin_rejection_reason_c1: formData.admin_rejection_reason_c1,
                    admin_update_datetime_c1: new Date().toISOString(),
                    admin_update_by_c1: sessionStorage.getItem('sitemanagement_emp_code'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin 1 Rejection" onClick={handleShow}>
                <CrossRed />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="admin_rejection_reason_c1" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Admin Rejection Reason  <span className="required">*</span>
                                </label>
                                <textarea
                                    id="admin_rejection_reason_c1"
                                    type="text"
                                    name="admin_rejection_reason_c1"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.admin_rejection_reason_c1}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.admin_rejection_reason_c1
                                        ? "error"
                                        : inputState.admin_rejection_reason_c1
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.admin_rejection_reason_c1 && (
                                    <span className="error-message font-size-text ">{errors.admin_rejection_reason_c1}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const ApprovedExpenseBillingAdminC2 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [formData, setFormData] = useState({});


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleFormSubmitPut = async (e) => {

        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                admin_approval_status_c2: "approved",
                admin_update_datetime_c2: new Date().toISOString(),
                admin_update_by_c2: sessionStorage.getItem('sitemanagement_emp_code'),
            };
            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Admin Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};

const RejectExpenseBillingAdminC2 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        admin_rejection_reason_c2: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["admin_rejection_reason_c2"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    admin_approval_status_c2: "rejected",
                    admin_rejection_reason_c2: formData.admin_rejection_reason_c2,
                    admin_update_datetime_c2: new Date().toISOString(),
                    admin_update_by_c2: sessionStorage.getItem('sitemanagement_emp_code'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin 2 Rejection" onClick={handleShow}>
                <CrossRed />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="admin_rejection_reason_c2" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Admin Rejection Reason  <span className="required">*</span>
                                </label>
                                <textarea
                                    id="admin_rejection_reason_c2"
                                    type="text"
                                    name="admin_rejection_reason_c2"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.admin_rejection_reason_c2}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.admin_rejection_reason_c2
                                        ? "error"
                                        : inputState.admin_rejection_reason_c2
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.admin_rejection_reason_c2 && (
                                    <span className="error-message font-size-text ">{errors.admin_rejection_reason_c2}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const ApprovedExpenseBillingAdminC3 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [formData, setFormData] = useState({});


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = []
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleFormSubmitPut = async (e) => {

        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                admin_approval_status_c3: "approved",
                admin_update_datetime_c3: new Date().toISOString(),
                admin_update_by_c3: sessionStorage.getItem('sitemanagement_emp_code'),
            };
            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, updatedFormData);

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-edit-button" title="Admin 3 Approval" onClick={handleShow}>
                <CheckGreen />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Admin Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};

const RejectExpenseBillingAdminC3 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        admin_rejection_reason_c3: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["admin_rejection_reason_c3"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, {
                    admin_approval_status_c3: "rejected",
                    admin_rejection_reason_c3: formData.admin_rejection_reason_c3,
                    admin_update_datetime_c3: new Date().toISOString(),
                    admin_update_by_c3: sessionStorage.getItem('sitemanagement_emp_code'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin 3 Rejection" onClick={handleShow}>
                <CrossRed />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="admin_rejection_reason_c3" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Admin Rejection Reason  <span className="required">*</span>
                                </label>
                                <textarea
                                    id="admin_rejection_reason_c3"
                                    type="text"
                                    name="admin_rejection_reason_c3"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.admin_rejection_reason_c3}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.admin_rejection_reason_c3
                                        ? "error"
                                        : inputState.admin_rejection_reason_c3
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.admin_rejection_reason_c3 && (
                                    <span className="error-message font-size-text ">{errors.admin_rejection_reason_c3}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ApproveRequestExpenseBillingAccStage2 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [fileName, setFileName] = useState("");
    const [formData, setFormData] = useState({
    });


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "settlement_transaction_id",
            "settlement_bill"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            setFormData({ ...formData, [name]: file, });
            setFileName(file.name);
        } else {
            setFileName("");
        }
    };

    const handleClear = () => {
        setFormData(prevState => ({
            ...prevState,
            settlement_bill: null
        }));
        setFileName("");

    }

    const handleFormSubmitPut = async (e) => {

        e.preventDefault();

        // const updatedFormData = {
        //     account_status_b: "approved",
        //     final_update_datetime: new Date().toISOString(),
        //     final_update_by: sessionStorage.getItem('sitemanagement_emp_code'),
        // };


        const formDataa = new FormData();

        const symbols = '!@#$%^&*()_-+=';
        const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz';
        const uppercaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const now = new Date();
        const date = now.toLocaleDateString('en-GB').split('/').reverse().join('-'); // Format: YYYY-MM-DD
        const time = now.toLocaleTimeString('en-GB', { hour12: false }).replace(/:/g, '-'); // Format: HH-MM-SS
        const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
        let randomCode = '';
        for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * allChars.length);
            randomCode += allChars[randomIndex];
        }
        if (formData.settlement_bill && formData.settlement_transaction_id) {
            const originalFile = formData?.settlement_bill;
            const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile?.name}`;
            const customFile = new File([originalFile], customFileName, { type: originalFile.type });

            formDataa.append("settlement_transaction_id", formData.settlement_transaction_id);
            formDataa.append("settlement_bill", customFile);
        }
        formDataa.append("account_status_b", "approved");
        formDataa.append("final_update_by", sessionStorage.getItem('sitemanagement_emp_code'));
        formDataa.append("final_update_datetime", new Date().toISOString());

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/vehiclerentbillingupdate/${i.id}/`, formDataa, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    setShow(false);
                } else {
                    alert(res);
                }

            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            {documentlist.length === 0 ? (<> <span className="error-message font-size-text " style={{ marginTop: '0px', marginBottom: '0px', paddingRight: '5px' }}>No Documents Attached</span></>) : (<>
                <button className="model-edit-button" title="Account Stage 1 Approval" onClick={handleShow}>
                    <CheckGreen />
                </button>
            </>)}
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">

                        <div className="bdy-div">
                            <h6 className="task-Tab-heading align-center font-weight500 font-size-heading">
                                Confirm Account Approval  "{i.project_short_name}"
                            </h6>

                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Approve
                                </button>
                            </div>
                        </div>


                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};
const RejectRequestExpenseBillingAccStage2 = ({ i, getofficebillingdata, documentlist }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [formData, setFormData] = useState({
        admin_rejection_reason: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["admin_rejection_reason"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/siteproject/imprest/${i.id}/`, {
                    admin_approval_status: "rejected",
                    authority_approval_status: "pending",
                    admin_rejection_reason: formData.admin_rejection_reason,
                    admin_update_datetime: new Date().toISOString(),
                    admin_update_by: sessionStorage.getItem('sitemanagement_emp_id'),
                });

                if (res.status === 200) {
                    await getofficebillingdata();
                    // setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button className="model-delete-button" title="Admin Imprest Reject" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M13.5 4.5L4.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 4.5L13.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row">
                                <label htmlFor="date" className="form-labels font-weight500 announce-date font-weight400  font-size-heading">
                                    Date :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.date ? formatDate(i.date) : "-"}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Months:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {getMonthName(i.month)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Year:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.year}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Project :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i?.vehicle_details?.project_short_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Name:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_name}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Vehicle Number:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.vehicle_num}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.fixed_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.extra_km}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Total Km:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {i.total_km}
                                </div>
                            </div>




                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Fixed Bill Amount:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Amount Per KM <br /> After Fixed KM :
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                </div>
                            </div>

                            <div className="flex-row">
                                <label
                                    htmlFor="project_name"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Extra Charges:
                                </label>
                                <div className="form-labels announce-date font-size-heading padding-lefttt">
                                    {formatCurrencyIndian(i.total_amt)}
                                </div>
                            </div>
                            <div className="flex-row">
                                <ViewDocumnetsbilling documentlist={documentlist} />
                            </div>
                            <div className="flex-column">
                                <label htmlFor="admin_rejection_reason" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Admin Rejection Reason
                                </label>
                                <textarea
                                    id="admin_rejection_reason"
                                    type="text"
                                    name="admin_rejection_reason"
                                    placeholder="Your Reason"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.admin_rejection_reason}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.admin_rejection_reason
                                        ? "error"
                                        : inputState.admin_rejection_reason
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.admin_rejection_reason && (
                                    <span className="error-message font-size-text ">{errors.admin_rejection_reason}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};



export {
    ApproveRequestExpenseBillingChecker,
    RejectRequestExpenseBillingChecker,

    ApproveRequestExpenseBillingAuthority,
    RejectRequestExpenseBillingAuthority,

    ApproveRequestExpenseBillingAccStage1,
    RejectRequestExpenseBillingAccStage1,
    ApprovedExpenseBillingAdminC1,
    ApprovedExpenseBillingAdminC2,
    ApprovedExpenseBillingAdminC3,
    RejectExpenseBillingAdminC1,
    RejectExpenseBillingAdminC2,
    RejectExpenseBillingAdminC3,

    ApproveRequestExpenseBillingAccStage2,
    RejectRequestExpenseBillingAccStage2,

}

